import React, { Fragment } from "react";
import styled from "styled-components";
import Content from "./Content";

const Contents = props => {
  const activeCheck = (data, idx) => {
    if (props.activeCoupon) {
      if (props.activeCoupon.issueCpnNo === data.issueCpnNo) {
        return true;
      } else {
        return false;
      }
    } else {
      if (idx === 0) {
        return true;
      } else {
        return false;
      }
    }
  };
  return (
    <ContentsBody>
      {props.contentList.map((item, i) => (
        <Content
          key={"content" + i}
          data={item}
          active={activeCheck(item, i)}
          setActiveCoupon={props.setActiveCoupon}
        />
      ))}
    </ContentsBody>
  );
};

const ContentsBody = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 0;
  flex-flow: wrap;
`;

export default Contents;
